import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
// A garden-deck sibling of floor-wood, in a slightly darker weathered oak.
const DECK = "#b98a52";
const GROOVE = "#9c703e";

export const deckTile = defineModel({
  id: "deck-tile",
  batchId: "modern",
  name: "Deck tile",
  tags: ["modern", "outdoor", "ground", "garden", "deck", "wood", "terrace"],
  summary: "A weathered oak terrace deck tile with plank grooves.",
  description:
    "A one-tile wooden terrace deck of the Modern Living kit: a 1x1 m " +
    "weathered-oak slab (0.06 m thick) with three darker plank grooves " +
    "running along X. Tiles seamlessly with every other ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    const grooves: Part[] = [];
    for (let i = 0; i < 3; i++) {
      grooves.push({
        geometry: new THREE.BoxGeometry(1.0, 0.012, 0.035),
        color: GROOVE,
        position: [0, 0.06, -0.25 + i * 0.25],
      });
    }
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: DECK, position: [0, 0.03, 0] },
      ...grooves,
    ];
  },
  animations: [],
});
